module.exports = __webpack_public_path__ + "img/1970East-040_WEB-min.e116343f.jpg";